import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component, ViewEncapsulation, inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ViewConfig, ViewModes } from '@spartacus/storefront';
import moment from 'moment';
import { combineLatest, Observable, BehaviorSubject, of, Subscription } from 'rxjs';
import { map, switchMap, startWith, skip } from 'rxjs/operators';
import { DtcSearchService } from 'src/app/services/feature/dtcSearch/dtc-search.service';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { SteeringGearService } from 'src/app/services/feature/steeringGear/steering-gear.service';
import { LanguageService } from '@spartacus/core';

@Component({
  selector: 'app-dtc-search',
  templateUrl: './dtc-search.component.html',
  styleUrls: ['./dtc-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DtcSearchComponent {
  private router = inject(Router);
  isMobile: boolean;
  dtcComponent$: Observable<{ key: string; value: any; }[]>;
  dtcType$: Observable<{ key: string; value: any; }[]>;
  dtcData: any;
  dtcData$ = new BehaviorSubject(null);
  dtcHasResult: any;
  submitted: boolean;
  sortControl = new FormControl('typeName_asc');
  subscription = new Subscription();
  searchResults: any;

  constructor() { }
  protected languageService = inject(LanguageService);
  ApiData: any;
  dtcService = inject(DtcSearchService);
  kbTempService = inject(ProductListService);
  productListService = inject(ProductListService);
  viewportScroller = inject(ViewportScroller);
  scrollConfig = inject(ViewConfig);
  cdr = inject(ChangeDetectorRef);
  private bpo = inject(BreakpointObserver);

  isInfiniteScroll: boolean | undefined;
  defaultPageSize: any = 10;

  productModel: any;
  viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  ViewModes = ViewModes;

  dtcDatabottomSection: boolean = false;

  dtcTypeValue: string | null = null;
  popupOpenCompanyName: boolean = false;
  //Method to initialize the form
  dtcSearchForm = new FormGroup({
    dtcComponent: new FormControl(null, { validators: Validators.required }),
    dtcType: new FormControl(null, { validators: Validators.required }),
    spn: new FormControl(null),
    fmi: new FormControl(null),
    internalCode1: new FormControl(null),
    internalCode2: new FormControl(null),
    blinkcode1: new FormControl(null),
    blinkcode2: new FormControl(null),
    hexcode: new FormControl(null),
  });
  makedata: Observable<{ key: string; value: any; }[]>;
  modelData: Observable<{ key: string; value: any; }[]>;

  get form() {
    return this.dtcSearchForm.controls;
  }

  updateValidators() {
    if (this.dtcTypeValue === 'SPN/FMI') {
      this.dtcSearchForm.get('hexcode')?.reset();
      this.dtcSearchForm.get('blinkcode1')?.reset();
      this.dtcSearchForm.get('blinkcode2')?.reset();
      this.dtcSearchForm.get('spn')?.setValidators(Validators.required);
      this.dtcSearchForm.get('fmi')?.setValidators(Validators.required);
      this.dtcSearchForm.get('blinkcode1')?.clearValidators();
      this.dtcSearchForm.get('blinkcode2')?.clearValidators();
      this.dtcSearchForm.get('hexcode')?.clearValidators();
      this.dtcSearchForm.get('hexcode')?.updateValueAndValidity();
      this.dtcSearchForm.get('blinkcode1')?.updateValueAndValidity();
      this.dtcSearchForm.get('blinkcode2')?.updateValueAndValidity();

    } else if (this.dtcTypeValue === 'Blink Code') {
      this.dtcSearchForm.get('hexcode')?.reset();
      this.dtcSearchForm.get('spn')?.reset();
      this.dtcSearchForm.get('fmi')?.reset();
      this.dtcSearchForm.get('internalCode1')?.reset();
      this.dtcSearchForm.get('internalCode2')?.reset();
      this.dtcSearchForm.get('spn')?.clearValidators();
      this.dtcSearchForm.get('fmi')?.clearValidators();
      this.dtcSearchForm.get('hexcode')?.clearValidators();
      this.dtcSearchForm.get('hexcode')?.updateValueAndValidity();
      this.dtcSearchForm.get('spn')?.updateValueAndValidity();
      this.dtcSearchForm.get('fmi')?.updateValueAndValidity();
      this.dtcSearchForm.get('blinkcode1')?.setValidators(Validators.required);
      this.dtcSearchForm.get('blinkcode2')?.setValidators(Validators.required);
    } else if (this.dtcTypeValue === 'Hex Code') {
      this.dtcSearchForm.get('blinkcode1')?.reset();
      this.dtcSearchForm.get('blinkcode2')?.reset();
      this.dtcSearchForm.get('spn')?.reset();
      this.dtcSearchForm.get('fmi')?.reset();
      this.dtcSearchForm.get('internalCode1')?.reset();
      this.dtcSearchForm.get('internalCode2')?.reset();
      this.dtcSearchForm.get('spn')?.clearValidators();
      this.dtcSearchForm.get('fmi')?.clearValidators();
      this.dtcSearchForm.get('blinkcode1')?.clearValidators();
      this.dtcSearchForm.get('blinkcode2')?.clearValidators();
      this.dtcSearchForm.get('spn')?.updateValueAndValidity();
      this.dtcSearchForm.get('fmi')?.updateValueAndValidity();
      this.dtcSearchForm.get('blinkcode1')?.updateValueAndValidity();
      this.dtcSearchForm.get('blinkcode2')?.updateValueAndValidity();
      this.dtcSearchForm.get('hexcode')?.setValidators(Validators.required);
    }
    else {
      this.dtcSearchForm.get('hexcode')?.reset();
      this.dtcSearchForm.get('spn')?.reset();
      this.dtcSearchForm.get('fmi')?.reset();
      this.dtcSearchForm.get('blinkcode1')?.reset();
      this.dtcSearchForm.get('blinkcode2')?.reset();
      this.dtcSearchForm.get('internalCode1')?.reset();
      this.dtcSearchForm.get('internalCode2')?.reset();
      this.dtcSearchForm.get('spn')?.clearValidators();
      this.dtcSearchForm.get('fmi')?.clearValidators();
      this.dtcSearchForm.get('blinkcode1')?.clearValidators();
      this.dtcSearchForm.get('blinkcode2')?.clearValidators();
      this.dtcSearchForm.get('hexcode')?.clearValidators();
    }
  }

  ngOnInit(): void {
    this.subscription.add(
      this.languageService.getActive().pipe(
        skip(1)
      ).subscribe(() => {
        this.dtcSearchFormreset();
        this.dtcHasResult = [];
        this.dtcData$.next(null);
      })
    );
    this.subscription.add(this.bpo.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe(result => {
      this.isMobile = result.matches;
      this.setViewMode(
        this.isMobile ? this.ViewModes.Grid : this.ViewModes.List
      );
    }));

    this.dtcComponent$ = this.languageService.getActive().pipe(
      switchMap(() => this.dtcService.getDtcComponent()),
      map(dtcComponent =>
        Object.keys(dtcComponent)
          .map(key => ({ key, value: dtcComponent[key] }))
          .sort((a, b) =>
            a.value.toLowerCase().localeCompare(b.value.toLowerCase())
          )
      )
    );

    this.dtcType$ = combineLatest([
      this.languageService.getActive(),
      this.dtcSearchForm.get('dtcComponent').valueChanges.pipe(
        startWith(this.dtcSearchForm.value.dtcComponent)
      ),
    ]).pipe(
      switchMap(([_, dtcComponent]) =>
        this.dtcService.getDtcType(dtcComponent)
      ),
      map(dtcType =>
        Object.keys(dtcType).map(key => ({
          key,
          value: dtcType[key],
        }))
      )
    );

    this.subscription.add(this.dtcSearchForm.get('dtcComponent').valueChanges.subscribe(res => {
      this.submitted = false;
      if (res) {
        this.updateValidators();
        this.dtcSearchForm.get('dtcType')?.reset();
      }
    }));
    
    this.subscription.add(this.dtcSearchForm.get('dtcType').valueChanges.subscribe(dtcType => {
      this.submitted = false;
      this.dtcTypeValue = dtcType;
      this.updateValidators();
      console.log(dtcType);
    }));

    this.subscription.add(
      this.dtcService.restoreSearch$.subscribe(restore => {
        if (restore) {
          const searchData = this.dtcService.getSearchData();
          if (searchData) {
            this.restoreSearchData(searchData);
          }
          this.dtcService.setRestoreSearch(false);
        }
      })
    );
  }

  restoreSearchData(searchData: any): void {

    this.dtcSearchForm.patchValue(searchData.formData, {
      emitEvent: false
    });

    this.dtcTypeValue = searchData.formData?.dtcType;

    const dtcComponent = searchData.formData?.dtcComponent;

    if (dtcComponent) {
      this.dtcType$ = this.dtcService.getDtcType(dtcComponent).pipe(
        map(dtcType => {
          return Object.keys(dtcType).map(key => ({
            key,
            value: dtcType[key]
          }));
        })
      );
    }

    this.dtcHasResult = searchData.searchResults;
    this.dtcData$.next(searchData.searchResults);

    this.submitted = searchData.submitted;
    this.dtcDatabottomSection = !!searchData.searchResults?.length;

    this.updateValidators();
    this.cdr.detectChanges();
  }

  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode);
  }
  sortControlValueChanged(el, currentArray) {
    const newValue = (el.target as HTMLSelectElement).value;
    this.sortBy(newValue, currentArray);
  }

  sortBy(option: string, currentArray) {
    const key = currentArray;
    const sortedArray = currentArray.slice();
    const [property, order] = option.split('_');
    this.dtcHasResult = sortedArray.sort((a, b) => {
      const aValue = a[property];
      const bValue = b[property];

      if (aValue < bValue) {
        return order === 'asc' ? -1 : 1;
      } else if (aValue > bValue) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  dtcSearchFormreset() {
    this.submitted = false;
    this.dtcDatabottomSection = false;
    this.dtcHasResult = [];
    this.dtcData$.next(null);
    this.dtcTypeValue = null;

    this.dtcSearchForm.reset({
      dtcComponent: null,
      dtcType: null,
      spn: '',
      fmi: '',
      internalCode1: '',
      internalCode2: '',
      blinkcode1: '',
      blinkcode2: '',
      hexcode: ''
    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.dtcDatabottomSection = false;
    if (this.dtcSearchForm.valid) {
      if (this.dtcTypeValue == "SPN/FMI") {
        const payLoadFormat =
        {
          component: this.form.dtcComponent.value,
          type: this.form.dtcType.value,
          fmi: this.form.fmi.value,
          spn: this.form.spn.value,
          internalCode1: this.form.internalCode1.value,
          internalCode2: this.form.internalCode2.value
        };
        this.subscription.add(this.dtcService.submitDtcData(payLoadFormat).subscribe(data => {
          this.dtcHasResult = data?.['kbDtcList'];
          this.dtcData$.next(data?.['kbDtcList']);
          this.dtcDatabottomSection = true;

          this.dtcService.setSearchData({
            formData: this.dtcSearchForm.getRawValue(),
            searchResults: data?.['kbDtcList'],
            submitted: true
          });

          this.cdr.detectChanges();
        }));
      } else if (this.dtcTypeValue == "Hex Code") {
        const payLoadFormat =
        {
          component: this.form.dtcComponent.value,
          type: this.form.dtcType.value,
          hexCode: this.form.hexcode.value,
        };
        this.subscription.add(this.dtcService.submitDtcData(payLoadFormat).subscribe(data => {
          this.dtcHasResult = data?.['kbDtcList'];
          this.dtcData$.next(data?.['kbDtcList']);
          this.dtcDatabottomSection = true;

          this.dtcService.setSearchData({
            formData: this.dtcSearchForm.getRawValue(),
            searchResults: data?.['kbDtcList'],
            submitted: true
          });

          this.cdr.detectChanges();
        }));
      }
      else {
        const payLoadFormat =
        {
          component: this.form.dtcComponent.value,
          type: this.form.dtcType.value,
          blinkCode1: this.form.blinkcode1.value,
          blinkCode2: this.form.blinkcode2.value,

        };
        this.subscription.add(this.dtcService.submitDtcData(payLoadFormat).subscribe(data => {
          this.dtcHasResult = data?.['kbDtcList'];
          this.dtcData$.next(data?.['kbDtcList']);
          this.dtcDatabottomSection = true;

          this.dtcService.setSearchData({
            formData: this.dtcSearchForm.getRawValue(),
            searchResults: data?.['kbDtcList'],
            submitted: true
          });

          this.cdr.detectChanges();
        }));
      }
    }
    else {
      return;
    }
  }
  openPopupCompanyName() {
    this.popupOpenCompanyName = true;
  }

  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }


  closePopupCompanyName() {
    this.popupOpenCompanyName = false;
  }
}
